import Ajax from "Utils/ajax";
export const getAllRole = (data) => Ajax.post('admin/getAllRole',data);
export const addUpdateRole = (data) => Ajax.post('admin/addUpdateRole',data);